import React from 'react';
import styled from 'styled-components';

import { buttonVariants, buttonWidths } from '@clatter/ui';
import { defaultBorderColor, primaryColor } from '../../themes';

const StyledButton = styled.button`
  color: #fff;
  border: 1px solid ${({ theme }) => theme?.palette?.primaryColor};
  background: ${({ theme }) => theme?.palette?.primaryColor};
  font-size: 14px;
  border-radius: 4px;
  padding: 0 16px;
  height: 40px;
  /* line-height: 38px; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &.full-width {
    width: 100%;

    span {
      margin: 0 auto;
    }
  }

  &:disabled {
    color:  ${({ theme }) => theme?.palette?.darkGrey}
  }

  .button-icon {
    font-size: 20px;

    + span {
      margin-left: 16px;
    }
  }

  &.button-primary {
    &:hover:not(:disabled) {
      cursor: pointer;
      border-color: ${primaryColor};
      background-color: #fff;
      color: ${primaryColor};
    }
  }

  &.button-secondary {
    background-color: ${({ theme }) => theme?.palette?.secondaryColor};
    border-color: ${({ theme }) => theme?.palette?.secondaryColor};
    color: #fff;
  }

  &.button-clear {
    color: #262626;
    background-color: #fff;
    border-color: #ddd;

    &:hover:not(:disabled) {
      border-color: #2768aa;
    }
  }

  &.${buttonVariants.danger} {
    background-color: ${({ theme }) => theme?.palette?.danger};
    border-color: ${({ theme }) => theme?.palette?.danger};

    &:hover:not(:disabled) {
      cursor: pointer;
      background-color: #fff;
      color: ${({ theme }) => theme?.palette?.danger};
    }
  }

  &.${buttonVariants.dark} {
    background-color: ${({ theme }) => theme?.palette?.darkGrey};
    border-color: ${({ theme }) => theme?.palette?.darkGrey};

    &:hover:not(:disabled) {
      cursor: pointer;
      background-color: #fff;
      color: ${({ theme }) => theme?.palette?.darkGrey};
    }
  }

  &.${buttonVariants.success} {
    background-color: ${({ theme }) => theme?.palette?.success};
    border-color: ${({ theme }) => theme?.palette?.success};

    &:hover:not(:disabled) {
      cursor: pointer;
      background-color: #fff;
      color: ${({ theme }) => theme?.palette?.success};
    }
  }

  &.${buttonVariants.warning} {
    background-color: ${({ theme }) => theme?.palette?.warning};
    border-color: ${({ theme }) => theme?.palette?.warning};

    &:hover:not(:disabled) {
      cursor: pointer;
      background-color: #fff;
      color: ${({ theme }) => theme?.palette?.warning};
    }
  }

  &:disabled {
    border-color: ${defaultBorderColor};
    color: ${defaultBorderColor};
    background-color: #fff;
    cursor: not-allowed;
  }

  &.${buttonWidths.sm} {
    padding: 0 16px;
  }

  &.${buttonWidths.md} {
    padding: 0 46px;
  }

  &.${buttonWidths.lg} {
    padding: 0 66px;
  }
`;

const Button = ({
  children,
  disabled = false,
  fullWidth = false,
  icon: Icon = null,
  onClick,
  type = 'button',
  variant = buttonVariants.primary,
  width = buttonWidths.sm,
  testId,
}) => (
  <StyledButton
    className={`${variant} ${width} ${fullWidth ? 'full-width' : ''}`}
    disabled={disabled}
    type={type}
    onClick={onClick}
    data-test-id={testId}
  >
    {!!Icon && <Icon className="button-icon" />}
    {!!children && <span>{children}</span>}
  </StyledButton>
);

export default Button;
